import { render } from "./SubscribersForm.vue?vue&type=template&id=0cddb9ba"
import script from "./SubscribersForm.vue?vue&type=script&lang=js"
export * from "./SubscribersForm.vue?vue&type=script&lang=js"

import "./SubscribersForm.vue?vue&type=style&index=0&id=0cddb9ba&lang=css"

import exportComponent from "D:\\Abdullah\\Projects\\R-Sport\\System\\rsport_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__